module.exports = __webpack_public_path__ + "static/media/26-12.ca6b868d.mp3";